document.querySelectorAll('.scroll-x-draggable, .yotpo-questions-list').forEach((slider) => {
    let isDown = false;
    let startX;
    let startY;
    let scrollLeft;
    let isHorizontal = false;

    function handleStart(e) {
        isDown = true;
        slider.classList.add('dragging');
        const clientX = e.touches ? e.touches[0].clientX : e.pageX;
        const clientY = e.touches ? e.touches[0].clientY : e.pageY;
        startX = clientX - slider.offsetLeft;
        startY = clientY - slider.offsetTop;
        scrollLeft = slider.scrollLeft;
        isHorizontal = false;
    }

    function handleEnd() {
        isDown = false;
        isHorizontal = false;
        slider.classList.remove('dragging');
    }

    function handleMove(e) {
        if (!isDown) return;
        
        const clientX = e.touches ? e.touches[0].clientX : e.pageX;
        const clientY = e.touches ? e.touches[0].clientY : e.pageY;
        const x = clientX - slider.offsetLeft;
        const y = clientY - slider.offsetTop;
        
        const deltaX = Math.abs(x - startX);
        const deltaY = Math.abs(y - startY);
        
        if (!isHorizontal && deltaX > deltaY && deltaX > 5) {
            isHorizontal = true;
        }
        
        if (isHorizontal) {
            e.preventDefault();
            const walk = (x - startX) * 1.5;
            slider.scrollLeft = scrollLeft - walk;
        }
    }

    slider.addEventListener('mousedown', handleStart);
    slider.addEventListener('mouseleave', handleEnd);
    slider.addEventListener('mouseup', handleEnd);
    slider.addEventListener('mousemove', handleMove);

    slider.addEventListener('touchstart', handleStart, { passive: true });
    slider.addEventListener('touchend', handleEnd);
    slider.addEventListener('touchcancel', handleEnd);
    slider.addEventListener('touchmove', handleMove, { passive: false });
});